export default __webpack_public_path__ + "static/media/chuva-forte.c61b9688.svg";